import { AutoMap } from '@automapper/classes';

export class InterventionEntity {
    Id?: number;
    @AutoMap()
    Code!: number;
    @AutoMap()
    Status!: number;
    @AutoMap()
    PlannedOn!: string;
    @AutoMap()
    PlannedOnTimeSlot!: number;
    @AutoMap()
    Comment?: string;
    SamplerId!: number;
    ContactId!: number;
    @AutoMap()
    StrategyId!: number;
    @AutoMap()
    Redactor!: string
    @AutoMap()
    ClientName!: string

    // SamplingPoint!: SamplingPointEntity;
    SamplingPointId?: number;

    AreaMapId?: number;
    ZoneIds?: number[];
    ProcessIds?: number[];
    LingetteIds?: number[];
    EauIds?: number[];
    MassifIds?: number[];
    AdductionIds?: number[];
    GenericIds?: number[];
    LingetteAreaMapTerrainIds?: number[];
}
